import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ColumnContainer } from 'utils/columnsStyle';
import { useRuleValidator } from 'hooks/useRuleValidator';
import { PERMISSIONS } from 'router/permissions';
import { addIotDeviceMode, editIotDeviceMode } from 'redux/actions/iotDevices/iotDevicesActions';

const style = { color: '#004F9F', fontSize: 20, marginRight: 10, cursor: 'pointer' };

const STATUS_LABELS = {
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
  MAINTENANCE: 'Mantenimiento',
  RETIRED: 'Retirado',
};

const ActionsCell = ({ original, onOpenEdit, onOpenAssign, onOpenUnassign }) => {
  const dispatch = useDispatch();
  const hist = useHistory();
  const canEdit = useRuleValidator(PERMISSIONS.IOT_DEVICES_EDIT);
  const canAssign = useRuleValidator(PERMISSIONS.IOT_DEVICES_ASSIGN);
  const isLinked = !!original.tank;

  const handleEdit = () => {
    dispatch(editIotDeviceMode());
    onOpenEdit(original);
  };

  return (
    <ColumnContainer>
      <OpenInNewIcon
        style={style}
        titleAccess="Ver detalle"
        onClick={() => hist.push(`/admin/iot-device/${original.id}`)}
      />
      {canEdit && <EditIcon style={style} titleAccess="Editar" onClick={handleEdit} />}
      {canAssign && !isLinked && (
        <LinkIcon
          style={{ ...style, color: '#2e7d32' }}
          titleAccess="Vincular a tanque"
          onClick={() => onOpenAssign(original)}
        />
      )}
      {canAssign && isLinked && (
        <LinkOffIcon
          style={{ ...style, color: '#c62828' }}
          titleAccess="Desvincular"
          onClick={() => onOpenUnassign(original)}
        />
      )}
    </ColumnContainer>
  );
};

export const columns = (onOpenEdit, onOpenAssign, onOpenUnassign) => [
  {
    Header: 'Identidad IoT',
    accessor: 'iotIdentity',
    filterable: true,
    filterMethod: (f, row) => row.iotIdentity?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Proveedor',
    accessor: 'provider',
    filterable: true,
    filterMethod: (f, row) => row.provider?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Marca / Modelo',
    id: 'brandModel',
    filterable: true,
    accessor: d => `${d.brand} ${d.model}`,
    filterMethod: (f, row) => row.brandModel?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Tipo medición',
    accessor: 'measurementType',
    filterable: true,
    filterMethod: (f, row) => row.measurementType?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Estatus',
    accessor: 'status',
    filterable: true,
    Cell: ({ value }) => STATUS_LABELS[value] ?? value,
    filterMethod: (f, row) => row.status?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Tanque',
    id: 'tankSerie',
    accessor: d => d.tank?.serie ?? '—',
    filterable: true,
    filterMethod: (f, row) => row.tankSerie?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Cliente',
    id: 'customerName',
    accessor: d => d.tank?.commodato?.customer?.name ?? '—',
    filterable: true,
    filterMethod: (f, row) => row.customerName?.toLowerCase().includes(f.value.toLowerCase()),
  },
  {
    Header: 'Última comunicación',
    accessor: 'lastCommunication',
    filterable: false,
  },
  {
    Header: 'Acciones',
    filterable: false,
    sortable: false,
    Cell: ({ original }) => (
      <ActionsCell
        original={original}
        onOpenEdit={onOpenEdit}
        onOpenAssign={onOpenAssign}
        onOpenUnassign={onOpenUnassign}
      />
    ),
  },
];
